"use client";
import { Container, AppButton } from "@/components";
import { motion } from "framer-motion";
import { Home, RefreshCcw } from "lucide-react";

export default function Error() {
  return (
    <section className="min-h-[70vh] flex items-center justify-center bg-white py-20 lg:py-40">
      <Container className="px-4 lg:px-10 flex flex-col items-center text-center">
        <div className="relative z-10 space-y-8">
          {/* Title */}
          <motion.h2
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.1 }}
            className="text-3xl lg:text-5xl font-black uppercase tracking-tighter leading-tight"
          >
            Something isn&apos;t <br />{" "}
            <span className="text-red-500">Responding.</span>
          </motion.h2>

          {/* Subtext */}
          <motion.p
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="text-lg text-muted-foreground max-w-lg mx-auto"
          >
            A minor glitch occurred in the matrix. Try refreshing the module or
            return to safety.
          </motion.p>

          {/* Actions */}
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.3 }}
            className="flex flex-col sm:flex-row items-center justify-center gap-6 pt-4"
          >
            {/* Using reset() to try re-rendering the component */}
            <AppButton
              onClick={() => window.location.reload()}
              buttonClass="h-10 px-10 bg-white text-black"
              icon={<RefreshCcw size={18} />}
            >
              Try Again
            </AppButton>

            <AppButton href="/" buttonClass="h-10 px-10" shadowClass="bg-black">
              <Home className="w-4 h-4" />
              <span className=""> Return Home</span>{" "}
            </AppButton>
          </motion.div>
        </div>
      </Container>
    </section>
  );
}
